export default __webpack_public_path__ + "static/N0019-c94095ffb50a737fbb13e15d025950e4.png";